<template>
  <b-row>
    <b-col v-for="item in legend" :key="'legend-'+item.variant" class="col-auto mb-2">
      <b-button
        variant="none"
        size="sm"
        class="mr-2"
        :style="`background-color: ${item.color};`"
      >
        <i :class="`fa fa-fw`"></i>
      </b-button>
      <span class="d-inline-block">{{ item.text }}</span>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    props: {
      organization: Object,
      legend: Array,
    },
    data() {
      return {
        trans: trans
      }
    },
  }
</script>